<template>
  <div>
    <div class="xsmall-hide small-hide bg-1"></div>
    <div class="medium-hide large-hide xlarge-hide">
      <img src="../assets/naniungo-slide-20.jpg" />
    </div>
    <div
      class="md-layout impressum"
      style="margin-left: 10vw; margin-right: 10vw"
    >
      <div class="md-layout-item">
        <h1>Impressum</h1>
        <br />
        <br />
        <h3>naniungo Deutschland GmbH</h3>
        <p>
          Kaistr. 5 <br />
          40221 Düsseldorf <br />
          Tel: 0211/ 7817 2880 <br />
          Fax: 0211/ 7817 2889 <br />
          info@naniungo.com
        </p>
        <p>
          <strong>Geschäftsführerin:</strong> <br />
          Nicole Ziegler
        </p>
        <p>
          <strong>Sitz der Gesellschaft</strong> <br />
          Düsseldorf Medienhafen
        </p>
        <p>
          <strong
            >Inhaltlich Verantwortlicher gemäß §7 TMG
            (Telemediengesetz):</strong
          >
          <br />
          Nicole Ziegler, Henrik Deitinghoff
        </p>
        <p>
          <strong>Registergericht</strong> <br />
          Amtsgericht Düsseldorf <br />
          Handelsregister HRB 85910 <br />
          Umsatzsteuer-Identifikationsnummer: <br />
          DE 323 023 286
        </p>
        <p>
          <strong>Angaben zur Berufshaftpflichtversicherung</strong> <br />
          Name und Sitz des Versicherers: <br />
          R+V Allgemeine Versicherungs AG <br />
          Voltastraße 84 <br />
          60486 Frankfurt <br />
          Geltungsraum der Versicherung: Deutschland
          <br />
        </p>
        <p>
          <strong>Konzeption und Realisierung</strong>
          <br />
          <a href="https://www.aopas.de">
            <img
              style="width: 80px; margin-bottom: 7px; margin-top: 5px"
              src="../assets/media/aopas_logo.png"
            /><br />
          </a>
          <strong>aopas software development</strong>
          <br />
          www.aopas.de
        </p>
        <p><strong>Bildnachweise:</strong></p>
        <p>
          Alle Bildrechte der auf der Webseite veröffentlichten Bilder liegen
          bei der naniungo Deutschland GmbH. Die Bilder sind 2019 in Düsseldorf
          an verschiedenen Orten (z.B. Düsseldorfer Medienhafen für die
          Außenaufnahmen oder Innenaufnahmen im Büro) entstanden. Das
          Bildmaterial wurde durch die Firma damato-Fotographie, Am Rothenbach
          15 in 48231 Warendorf produziert und bearbeitet. Alle gezeigten
          Personen haben schriftlich die Bildrechte für die Darstellung auf der
          Webseite oder Unternehmensbroschüren zur Verfügung gestellt. Alle
          extern gekauften Bilder werden gesondert gekennzeichnet.
        </p>
        <p><strong>Streitschlichtung</strong></p>
        <p>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:
          <a href="https://ec.europa.eu/consumers/odr"
            >https://ec.europa.eu/consumers/odr</a
          >.
          <br />
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
        <p><strong>Disclaimer/Haftungsausschluß</strong></p>
        <p><strong>Haftung für Inhalte</strong></p>
        <p>
          Als Diensteanbieter ist die naniungo Deutschland GmbH gemäß § 7 Abs.1
          TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
          verantwortlich. Nach §§ 8 bis 10 TMG ist die Gesellschaft als
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
          gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
          forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
          Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
          von entsprechenden Rechtsverletzungen wird die naniungo Deutschland
          GmbH diese Inhalte umgehend entfernen.
        </p>
        <p>
          Die naniungo Deutschland GmbH übernimmt somit keinerlei Gewähr für die
          Aktualität, Korrektheit, Vollständigkeit oder Qualität der
          Informationen auf der Website. Haftungsansprüche, die sich auf Schäden
          materieller oder ideeller Art beziehen, sind grundsätzlich
          ausgeschlossen, auch wenn sie durch die Nutzung oder Nichtnutzung der
          dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und
          unvollständiger Informationen verursacht wurden.
        </p>
        <p>
          Die Gesellschaft behält sich vor, Teile der Seiten oder das gesamte
          Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu
          löschen oder die Veröffentlichung zeitweise oder endgültig
          einzustellen.
        </p>
        <p><strong>Haftung für Links und Verweise</strong></p>
        <p>
          Das Angebot der naniungo Deutschland GmbH enthält Links zu externen
          Websites Dritter, auf deren Inhalte die Gesellschaft keinen Einfluss
          hat. Deshalb wird für diesen fremden Inhalt auch keine Gewähr
          übernommen. Für die Inhalte der verlinkten Seiten ist stets der
          jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die
          verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche
          Rechtsverstöße unserer Rechtsabteilung überprüft. Rechtswidrige sowie
          illegale Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
          Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder die
          Urheberschaft der verlinkten Seiten hat die naniungo Deutschland GmbH
          keinen Einfluss. Deshalb distanziert sich die Gesellschaft hiermit
          ausdrücklich von den Inhalten aller verlinkten Seiten. Diese
          Feststellung gilt für alle innerhalb des eigenen Internetangebotes
          gesetzten Links und Verweise. Für illegale, fehlerhafte oder
          unvollständige Inhalte und insbesondere für Schäden, die aus der
          Nutzung oder Nichtnutzung solcher Informationen entstehen, haftet
          nicht derjenige, der über Links auf die jeweilige Veröffentlichung
          lediglich verweist, sondern allein der Anbieter der Website, auf die
          von unserer Website verwiesen wurde. Eine permanente inhaltliche
          Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte
          einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
          Rechtsverletzungen wird die naniungo Deutschland GmbH derartige Links
          umgehend entfernen.
        </p>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
          Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
          jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
          sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          Somit ist die Gesellschaft bestrebt, primär in allen Publikationen auf
          selbsterstellte Grafiken, Tondokumente, Videosequenzen und Texte
          zurückzugreifen bzw. bei externen Quellen, die Urheber
          kenntlichzumachen. Soweit die Inhalte oder Bildmaterial auf dieser
          Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
          Dritter beachtet und liegen der Gesellschaft schriftlich vor. Sollten
          Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
          bitten wir um einen entsprechenden Hinweis und Kontaktaufnahme der
          Rechtsabteilung der naniungo Deutschland GmbH. Bitte senden Sie uns in
          diesem Fall eine Email an info@naniungo.com. Bei Bekanntwerden von
          Rechtsverletzungen wird die Gesellschaft derartige Inhalte umgehend
          entfernen.
        </p>
        <p><strong>Datenschutz:</strong></p>
        <p>
          Auf der Webseite der naniungo Deutschland GmbH besteht die
          Möglichkeit, persönliche oder geschäftlicher Daten (E-Mail-Adressen,
          Namen, Anschriften oder Kurzmitteilungen) in die jeweiligen
          Datenfenster einzugeben. Diese Eingabe bzw. die Preisgabe dieser Daten
          seitens des Nutzers erfolgen auf ausdrücklich freiwilliger Basis.
        </p>
        <p>
          Gemäß gültiger Datenschutzgesetze haben Sie das Recht, alle
          Personendaten einzusehen und zu korrigieren, die die Gesellschaft über
          Sie gesammelt hat. Wenden Sie sich dazu bitte an
          <a href="mailto:datenschutz@de.naniungo.com">info@ naniungo.com</a>
          oder unseren Externen Datenschutzbeauftragten: Herrn Volker Wassermann
        </p>
        <h3>Google</h3>
        <p>
          Diese Website benutzt Google Analytics, einen Webanalysedienst der
          Google Inc. („Google“). Google Analytics verwendet sog. „Cookies“,
          Textdateien, die auf Ihrem Computer gespeichert werden und die eine
          Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den
          Cookie erzeugten Informationen über Ihre Benutzung dieser Website
          werden in der Regel an einen Server von Google in den USA übertragen
          und dort gespeichert. Im Falle der Aktivierung der IP-Anonymisierung
          auf dieser Webseite, wird Ihre IP-Adresse von Google jedoch innerhalb
          von Mitgliedstaaten der Europäischen Union oder in anderen
          Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum
          zuvor gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an
          einen Server von Google in den USA übertragen und dort gekürzt. Im
          Auftrag des Betreibers dieser Website wird Google diese Informationen
          benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die
          Websiteaktivitäten zusammenzustellen und um weitere mit der
          Websitenutzung und der Internetnutzung verbundene Dienstleistungen
          gegenüber dem Websitebetreiber zu erbringen. Die im Rahmen von Google
          Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit
          anderen Daten von Google zusammengeführt. Sie können die Speicherung
          der Cookies durch eine entsprechende Einstellung Ihrer
          Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass
          Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser
          Website vollumfänglich werden nutzen können. Sie können darüber hinaus
          die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der
          Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die
          Verarbeitung dieser Daten durch Google verhindern, indem sie das unter
          dem folgenden Link (http://tools.google.com/dlpage/gaoptout?hl=de)
          verfügbare Browser-Plugin herunterladen und installieren. Nähere
          Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter
          www.naniungo.com/datenschutz. Wir weisen Sie darauf hin, dass auf
          dieser Webseite Google Analytics um den Code „gat._anonymizeIp();“
          erweitert wurde, um eine anonymisierte Erfassung von IP-Adressen (sog.
          IP-Masking) zu gewährleisten.
        </p>
        <h3>Facebook</h3>
        <p>
          Unsere Website nutzt ein Plug-in des sozialen Netzwerks Facebook. Das
          Plug-in ist an dem Facebook-Logo oder dem Like-Button erkennbar. Wenn
          Sie die Webseite der naniungo Deutschland GmbH besuchen, informiert
          das Plug-in den Facebook-Server über Ihren Besuch. Falls Sie unsere
          Website oder einzelne Seiten liken (den Gefällt-mir-Button klicken),
          während Sie bei Facebook eingeloggt sind, verlinken Sie Inhalte
          unserer Website mit Ihrem Facebook-Profil. Auf diese Weise ist es
          Facebook möglich, Ihren Besuch Ihrem Benutzerkonto zuzuordnen. Die
          dabei übermittelten Daten kennt ausschließlich Facebook, die naniungo
          Deutschland GmbH hat keine Einblicke in die Daten selbst und deren
          Nutzung durch Facebook. Mehr Informationen erhalten Sie in der
          Datenschutzerklärung von Facebook unter:
          www.de-de.facebook.com/policy.php
        </p>
        <p><strong>Salvatorische Klausel:</strong></p>
        <p>
          Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden
          Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen
          sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und
          ihrer Gültigkeit davon unberührt. Alle Rechte vorbehalten. Die
          Veröffentlichung des Inhalts dieses Web-Angebotes bedarf der
          ausdrücklichen Genehmigung durch die naniungo Deutschland GmbH. Die
          Veröffentlichung und die Auswertung der Presseinformationen ist
          gestattet. Alle Bilder sind urheberrechtlich geschützt und dürfen nur
          mit ausdrücklicher Genehmigung des Rechtinhabers verwendet werden.
        </p>
        <p>
          <strong
            >Das Impressum gilt auch für folgende Social Media Profile:</strong
          >
        </p>
        <p>
          <a href="https://www.xing.com/companies/naniungodeutschlandgmbh"
            >https://www.xing.com/companies/naniungodeutschlandgmbh</a
          >
          <br />
          <a href="https://www.linkedin.com/company/naniungo-deutschland-gmbh/"
            >https://www.linkedin.com/company/naniungo-deutschland-gmbh/</a
          >
          <br />
          <a href="https://twitter.com/naniungo">https://twitter.com/naniungo</a
          ><br />
          <a href="https://www.facebook.com/naniungo"
            >https://www.facebook.com/naniungo</a
          ><br />
          <a
            href="https://www.google.com/maps/place/naniungo+Deutschland+GmbH/@51.2140528,6.746894,17z/data=!3m1!4b1!4m5!3m4!1s0x47b8cbe45d34786d:0xe96bab2864badc78!8m2!3d51.2140495!4d6.7490827"
            >https://www.google.com/maps/place/naniungo+Deutschland+GmbH/@51.2140528,
            <br />6.746894,17z/data=!3m1!4b1!4m5!3m4!1s0x47b8cbe45d34786d:0xe96bab2864badc78!8m2!3d51.2140495!4d6.7490827</a
          >
          <br />
          <br />
        </p>
        <p>
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
          für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten
          sind ausschließlich deren Betreiber verantwortlich.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Impressum",
  data() {
    return {
      firstName: "",
      lastName: "",
      jobTitle: "",
      emailAddressPrivate: "",
      phoneNumberBusiness: "",
      hobbies: "",
      ambition: "",
      level: "",
      function: "",
      carerix_id: "",
      functionOne: "",
      method: "",
      varCandidates: [
        {
          ambition: "",
          isOpen: false,
          addtoCart: false,
          carerix_id: "",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      candidates: (state) => state.candidates.candidates,
      cart: (state) => state.cart.cart,
    }),
  },
  created() {
    // this.$store.dispatch('candidates/getCandidates');
  },
  methods: {
    ...mapActions("candidates", "cart", [
      "addCandidate",
      "deleteCandidate",
      "updateCandidate",
      "getCart",
    ]),
    toggleOpen(value) {
      var item = this.varCandidates.filter((obj) => {
        return obj.ambition === value;
      })[0];

      if (typeof item !== "undefined") {
        item.isOpen = !item.isOpen;
      }
    },
    getToggleState(value) {
      const item = this.varCandidates.filter((obj) => {
        return obj.ambition === value;
      })[0];
      if (typeof item !== "undefined") {
        return item.isOpen;
      }
    },
    toggleCart(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter((obj) => {
        return obj.ambition === value;
      })[0];
      if (typeof item !== "undefined") {
        item.addtoCart = !item.addtoCart;
      }
    },
    getCartState(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter((obj) => {
        return obj.ambition === value;
      })[0];
      if (typeof item !== "undefined") {
        return item.addtoCart;
      }
    },
  },
  mounted() {
    // if (localStorage.getItem('toggle') === 'true' && localStorage.getItem('toggle').length ===  this.$store.state.candidates.candidates.length) {
    if (localStorage.getItem("varCandidates")) {
      this.varCandidates = JSON.parse(localStorage.getItem("varCandidates"));
    } else {
      for (var i in this.$store.state.candidates.candidates) {
        var item = this.$store.state.candidates.candidates[i];
        this.varCandidates.push({
          ambition: item.ambition,
          isOpen: false,
          addtoCart: false,
          carerix_id: item.carerix_id,
        });
      }
    }
  },
  watch: {
    varCandidates: {
      handler() {
        localStorage.setItem(
          "varCandidates",
          JSON.stringify(this.varCandidates)
        );
        this.$store.dispatch("cart/getCart");
        // this.getCart();
      },
      deep: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/css/shared.scss";
.bg-1 {
  background: url("../assets/naniungo-slide-20.jpg") no-repeat center center
    fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 500px;
}
</style>
